import React from "react";
import FileIcon from "./FileIcon";
import Icon from "./Icon";

function formatDate(dateStr) {
  if (!dateStr || dateStr === "--") return "--";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const now = new Date();
    const diff = now - date;
    if (diff < 60000) return "Just now";
    if (diff < 3600000) return Math.floor(diff / 60000) + " min ago";
    if (diff < 86400000) return Math.floor(diff / 3600000) + " hr ago";
    if (diff < 604800000) return Math.floor(diff / 86400000) + " days ago";
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return dateStr;
  }
}

function FileListView({ files, currentPath, onNavigate, onFileClick, onContextMenu, isSearch }) {
  const handleClick = (item) => {
    if (onFileClick) onFileClick(item);
    else if (item.type === "folder") {
      const path = currentPath === "/" ? `/${item.name}` : `${currentPath}/${item.name}`;
      onNavigate(path);
    }
  };

  return (
    <div className="file-list gd-file-list">
      <div className="file-list-header gd-list-header">
        <div className="col-icon"></div>
        <div className="col-name">Name</div>
        <div className="col-owner">Owner</div>
        <div className="col-modified">{isSearch ? "Location" : "Modified"}</div>
        <div className="col-size">Size</div>
        <div className="col-actions"></div>
      </div>

      {files.map((item, i) => (
        <div
          key={`${item.name}-${i}`}
          className="file-row gd-list-row clickable"
          data-file-id={item.id}
          onClick={() => handleClick(item)}
          onContextMenu={(e) => onContextMenu(e, item)}
        >
          <div className="col-icon">
            <FileIcon type={item.type} ext={item.ext} />
          </div>
          <div className="col-name">
            <span className="file-name-text">{item.name}</span>
            {item.restricted && (
              <span className="restricted-badge" title="Access restricted">
                <Icon name="lock" size={12} />
              </span>
            )}
            {item.status === "pending_upload" && (
              <span className="pending-badge" title="Upload pending">
                <Icon name="clock" size={12} />
              </span>
            )}
          </div>
          <div className="col-owner">{item.owner || "--"}</div>
          <div className="col-modified">
            {isSearch ? (item.location === "/" ? "All Files" : item.location) : formatDate(item.modified)}
          </div>
          <div className="col-size">{item.type === "folder" ? "--" : (item.size || "--")}</div>
          <div className="col-actions">
            <button
              className="action-menu-btn gd-kebab"
              onClick={(e) => { e.stopPropagation(); onContextMenu(e, item); }}
            >
              <Icon name="more" size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FileListView;
